















import { Component, Vue, Prop } from "vue-property-decorator";
import ModalTemplate1 from "./template1.vue";
import ModalTemplate2 from "./template2.vue";
import ModalTemplateScans from "./templateScans.vue";

@Component({
    components: {
        template_1: ModalTemplate1,
        template_2: ModalTemplate2,
        template_scans: ModalTemplateScans
    }
})
export default class ModalWrapper extends Vue {
    @Prop({ default: () => [] }) modals!: any;
}
